import { render, staticRenderFns } from "./MastersItem.vue?vue&type=template&id=09d8f89d&scoped=true"
import script from "./MastersItem.vue?vue&type=script&lang=js"
export * from "./MastersItem.vue?vue&type=script&lang=js"
import style0 from "./MastersItem.vue?vue&type=style&index=0&id=09d8f89d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8f89d",
  null
  
)

export default component.exports